import classNames from 'classnames';
import { motion } from 'framer-motion';

export const HorizontalBarChart: React.FC<{
  maxValue?: number;
  dataset: {
    id: string;
    label: string;
    data: { _id: string; value: number; suffix?: string; color: string }[];
  }[];
}> = ({ dataset, maxValue = 100 }) => {
  return (
    <div className="flex w-full flex-col space-y-6">
      {dataset.map(({ data, id, label }, index) => {
        const isStacked = data.length > 1;
        const transition = {
          ease: 'easeOut',
          duration: 0.4,
          delay: index * 0.1,
        } as const;

        return (
          <div key={id} className="flex w-full flex-col space-y-3">
            {label && <span className="flex-1 leading-normal">{label}</span>}

            <motion.div
              className="relative flex h-9 w-full overflow-hidden rounded-sm bg-neutral-4/20"
              initial="hidden"
              viewport={{ once: true }}
              whileInView="visible"
            >
              {/* Scaling one wrapper grows every segment together without animating width */}
              <motion.div
                className="flex w-full origin-left"
                transition={transition}
                variants={{
                  hidden: { opacity: 0, scaleX: 0 },
                  visible: { opacity: 1, scaleX: 1 },
                }}
              >
                {data.map(({ _id, color, value }) => (
                  <div
                    key={_id}
                    style={{
                      width: `${value * (100 / maxValue)}%`,
                      background: color,
                    }}
                  />
                ))}
              </motion.div>
              {data.map(({ _id, suffix, value }, _index) => (
                <motion.span
                  key={_id}
                  className={classNames(
                    !isStacked || _index === 0 ? 'left-0' : 'right-0',
                    'absolute z-10 flex h-9 items-center justify-center p-3 font-bold leading-normal',
                  )}
                  transition={transition}
                  variants={{
                    hidden: { opacity: 0 },
                    visible: { opacity: 1 },
                  }}
                >
                  {value}
                  {suffix || null}
                </motion.span>
              ))}
            </motion.div>
          </div>
        );
      })}
    </div>
  );
};
